/* ============================================================
 * DN — Jotly size-chart button i18n patch
 *
 * The Jotly Size Charts app hardcodes the button label in Italian
 * ("Trova la mia taglia") from app admin — no native i18n support.
 * We detect the current locale and replace the text node on non-IT
 * locales. Jotly updates the text dynamically (data-jsc-update-text),
 * so we keep a narrow observer on the button and self-disconnect
 * while writing to avoid feedback loops.
 *
 * Extend I18N when new locales go live (fr, de, es, …).
 *
 * Owner: FastCorp — rev 22 apr 2026
 * ============================================================ */

(function () {
  'use strict';

  var I18N = {
    en: { 'Trova la mia taglia': 'Find my size' }
  };

  function getLocale() {
    if (window.Shopify && Shopify.locale) return String(Shopify.locale).toLowerCase();
    var h = document.documentElement.lang;
    if (h) return h.split('-')[0].toLowerCase();
    var m = location.pathname.match(/^\/([a-z]{2})\//);
    return m ? m[1] : 'it';
  }

  var locale = getLocale();
  var table = I18N[locale];
  if (!table) return; // IT default or unsupported locale — no-op

  var SELECTOR = '#jsc-trigger-button';
  var btnObs = null;

  function translateNode(btn) {
    for (var i = 0; i < btn.childNodes.length; i++) {
      var n = btn.childNodes[i];
      if (n.nodeType !== 3) continue; // text node only
      var raw = n.nodeValue;
      var trimmed = raw.trim();
      if (trimmed && table[trimmed]) {
        n.nodeValue = raw.replace(trimmed, table[trimmed]);
      }
    }
  }

  function attachButtonObserver(btn) {
    if (btnObs) btnObs.disconnect();
    translateNode(btn);
    btnObs = new MutationObserver(function () {
      btnObs.disconnect();
      translateNode(btn);
      btnObs.observe(btn, { childList: true, subtree: true, characterData: true });
    });
    btnObs.observe(btn, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    var btn = document.querySelector(SELECTOR);
    if (btn) {
      attachButtonObserver(btn);
      return;
    }
    // Button not yet injected by Jotly — watch DOM for it
    var docObs = new MutationObserver(function () {
      var b = document.querySelector(SELECTOR);
      if (b) {
        docObs.disconnect();
        attachButtonObserver(b);
      }
    });
    docObs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
